import { useState } from "react";
import ActivityWorkOrder from "features/mechanicalWork/ActivityWorkOrder";
import LinkedTicketDialog from "features/mechanicalWork/components/WorkOrderLinkedTickets/LinkedTicketDialog";

export const useWorkOrderDialog = () => {
    const [workOrderId, setWorkOrderId] = useState();
    const [ticketId, setTicketId] = useState();

    const openWorkOrder = (id) => setWorkOrderId(id);

    const workOrderDialog = (
        <>
            {!!workOrderId &&
                <ActivityWorkOrder
                    workOrderId={workOrderId}
                    withDialog
                    onClose={() => setWorkOrderId(null)}
                    onOpenTicket={(id) => { setWorkOrderId(null); setTicketId(id); }}
                />
            }
            {!!ticketId &&
                <LinkedTicketDialog
                    ticketId={ticketId}
                    onClose={() => setTicketId(null)}
                    onOpenWorkOrder={(id) => { setTicketId(null); setWorkOrderId(id); }}
                />
            }
        </>
    );

    return { openWorkOrder, workOrderDialog };
};
